import { render, staticRenderFns } from "./GroupRow.vue?vue&type=template&id=7c43af7a"
import script from "./GroupRow.vue?vue&type=script&lang=ts"
export * from "./GroupRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c43af7a')) {
      api.createRecord('7c43af7a', component.options)
    } else {
      api.reload('7c43af7a', component.options)
    }
    module.hot.accept("./GroupRow.vue?vue&type=template&id=7c43af7a", function () {
      api.rerender('7c43af7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/groups/GroupRow.vue"
export default component.exports